/**
 * `/market/trials` — the bounded looks this account has taken (M4b).
 */
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/market/trials')({});
